import { render } from "./bookmark_button.vue?vue&type=template&id=2d90e4c7"
import script from "./bookmark_button.js?vue&type=script&lang=js"
export * from "./bookmark_button.js?vue&type=script&lang=js"

import "./bookmark_button.vue?vue&type=style&index=0&id=2d90e4c7&lang=scss"

import exportComponent from "/home/jojo/Documents/aspho-fe-pleromer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__